/*
 * @Author: your name
 * @Date: 2022-04-26 11:40:52
 * @LastEditTime: 2022-04-26 18:17:11
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /yach_31_record/packages/auxiliary_ability/src/containers/app/Provider.tsx
 */
import React, { createContext, ReactElement } from 'react'
import { Observer } from 'mobx-react'

import * as store from '@store/index'

interface ChildrenProps<T> {
    children: (value: T) => ReactElement<any>
}

export const RootContext = createContext<IStore>(null)

/**
 * 已包含Observer
 * @param param0
 */
export const RootConsumer = ({ children }: ChildrenProps<IStore>) => <Observer>{() => children(store)}</Observer>

const Provider: React.FC<ChildrenNode> = ({ children }) => {
    return <RootContext.Provider value={{ ...store }}>{children}</RootContext.Provider>
}

export default Provider
